export default __webpack_public_path__ + "static/media/Bug.3c505733.png";